import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-food",
  "use": "icon-food-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-food\">\r\n  <path d=\"M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32z m-40 632H136V232h752v560z\" fill=\"currentColor\" />\r\n  <path d=\"M540 420c0-22.1-17.9-40-40-40h-60c-22.1 0-40 17.9-40 40v200c0 22.1 17.9 40 40 40h60c22.1 0 40-17.9 40-40V420z m-80 180h-20V440h20v160z\" fill=\"currentColor\" />\r\n  <path d=\"M700 380c-22.1 0-40 17.9-40 40v60h-40v-60c0-22.1-17.9-40-40-40s-40 17.9-40 40v200c0 22.1 17.9 40 40 40s40-17.9 40-40v-60h40v60c0 22.1 17.9 40 40 40s40-17.9 40-40V420c0-22.1-17.9-40-40-40z\" fill=\"currentColor\" />\r\n  <path d=\"M340 380c-66.3 0-120 53.7-120 120s53.7 120 120 120 120-53.7 120-120-53.7-120-120-120z m0 180c-33.1 0-60-26.9-60-60s26.9-60 60-60 60 26.9 60 60-26.9 60-60 60z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/food.svg
// module id = /LXy
// module chunks = 117